<template>
  <div class="mfr-container">
    <h6 style="padding-top: 20px;">{{$t('map.room_nums')}}
      <span v-if="false" @click='toggleDX'>{{$t('room_info_popup.duplex')}}
        <img v-if="$store.getters.filter.duplex == 'Y'" src="../../../assets/image/ic_check_on@2x.png" class="img_check">
        <img v-if="$store.getters.filter.duplex != 'Y'" src="../../../assets/image/ic_check_off@2x.png" class="img_check">
      </span>
<!--      <small>{{$t('map.multi_selection')}}</small>-->
    </h6>
    <div class="mt-2 mb-2">
      <b-button v-for="(k,i) in $c.ROOM_NUM_SELECT1.filter((it, _idx) => {return _idx > 0})" variant="white" size="sm"
                :pressed="$store.getters.filter.room_num === i"
                @click="() => {
                  $store.getters.filter.room_num = i;
                  $store.getters.filter.room_more = '';
                  $store.getters.filter.room_list = $store.getters.filter.room_list.map(item => {
                    item.room = i;
                    return item;
                  })
                }":key="i">{{k}}</b-button>
    </div>

    <h6 class="mt-4">{{$t('map.toilet_nums')}}
<!--      <small>{{$t('map.multi_selection')}}</small>-->
    </h6>
    <div class="mt-2 mb-2">
      <b-button v-for="(k,i) in Object.keys($c.MF_TOILET1)" variant="white" size="sm"
                :pressed="$store.getters.filter.toilet_num == $c.MF_TOILET1[k]"
                @click="() => {$store.getters.filter.toilet_num = i + 1; $store.getters.filter.toilet_more = ''}" :key="i">{{k}}</b-button>
    </div>

    <h6 class="mt-4">{{$t('site_detail.dup_teras1')}}</h6>
    <div class="mt-2 mb-2">
      <b-button variant="white" size="sm"
                :pressed="$store.getters.filter.duplex == 'Y'"
                @click="toggleDX()">{{$t('room_info_popup.duplex')}}</b-button>
      <b-button variant="white" size="sm"
                :pressed="$store.getters.filter.teras == 'Y'"
                @click="toggleTR()">{{$t('site_detail.teras')}}</b-button>
    </div>
    <template v-if="false">
      <h6 class="mt-3">{{$t('map.elevator')}}</h6>
      <div class="mt-3 mb-2">
        <b-button v-for="(v,k,i) in $c.MF_ELEVATOR" variant="white" size="sm" :pressed="checkEF(v)" @click="toggleEF(v)" :key="i">{{k}}</b-button>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'MFRoom',
  methods: {
    toggleDX() {
      if (this.$store.getters.filter.duplex == 'Y')
        this.$store.commit('setFilter', {duplex: ''});
      else
        this.$store.commit('setFilter', {duplex: 'Y'});
    },
    toggleTR() {
      if (this.$store.getters.filter.teras == 'Y')
        this.$store.commit('setFilter', {teras: ''});
      else
        this.$store.commit('setFilter', {teras: 'Y'});
    },
    checkRF(val) {
      // var flts = (this.$store.getters.filter.room_num == '' ? [] :
      //             this.$store.getters.filter.room_num.split(','));
      // if (val == '')
      //   return (flts.length == 0);
      // else
      //   return (flts.indexOf(val) != -1);
      this.$store.getters.filter.room_num === val
    },
    toggleRF: function (val) {
      // if (val == '') {
      //   this.$store.commit('setFilter', {room_num: ''});
      //   return;
      // }
      // var flts = (this.$store.getters.filter.room_num == '' ? [] :
      //             this.$store.getters.filter.room_num.split(','));
      // var idx = flts.indexOf(val);
      // if (idx != -1)
      //   flts.splice(idx, 1);
      // else
      //   flts.push(val);
      // this.$store.commit('setFilter', {room_num: flts.join(',')});
      this.$store.getters.filter.room_num = val;
      this.$store.getters.filter.room_more = '';
      this.$store.getters.filter.room_list = this.$store.getters.filter.room_list.map(item => {
        item.room = val;
        return item;
      })
    },
    checkTF: function(val) {
      var flts = (this.$store.getters.filter.toilet_num == '' ? [] :
                  this.$store.getters.filter.toilet_num.split(','));
      return (flts.indexOf(val) != -1);
    },
    toggleTF: function (val) {
      var flts = (this.$store.getters.filter.toilet_num == '' ? [] :
                  this.$store.getters.filter.toilet_num.split(','));
      var idx = flts.indexOf(val);
      if (idx != -1)
        flts.splice(idx, 1);
      else
        flts.push(val);
      this.$store.commit('setFilter', {toilet_num: flts.join(',')});
    },
    checkEF: function(val) {
      return (this.$store.getters.filter.elevator == val);
    },
    toggleEF: function (val) {
      if (this.$store.getters.filter.elevator != val)
        this.$store.commit('setFilter', {elevator: val});
      else
        this.$store.commit('setFilter', {elevator: ''});
    },
  },
}
</script>

<style scoped lang="scss">
  @import '../../../assets/css/_vars.scss';
  h6 {
    font-size: $fs_18;
    font-family: $korean_gd_17_r;
  }
  h6>span {
    font-size: $fs_20;
    font-family: $korean_gd_14_r;
    color: $c_457fff;
  }
  h6>small {
    //color: #ccc9c9;
    color: $trading1;
    font-size: $fs_18;
    font-family: $korean_gd_13_r;
  }
  div.mfr-container {
    padding: 0px 40px 10px;
    background-color: white;
    width: 100%;
    margin: auto;
  }
  button {
    margin-right: 8px;
    font-size: $fs_16;
    font-family: $korean_gd_14_r;
    border-width: 0.5px;
    border-radius: 5px;
    border-color: #eeeeef;
    height: 40px;
    padding: .375rem .75rem;
  }
   .img_check {
    width: 20px;
    height: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/controls/mf/MFRoom.vue